import Cookie from 'js-cookie'

export const get = Cookie.get;
export const set = Cookie.set;
export const remove = Cookie.remove;
export const getJSON = Cookie.getJSON;